<template>
    <jet-authentication-card>
        <template #logo>
            <jet-authentication-card-logo />
        </template>

        <div class="mb-4 text text-gray-600 mt-5 text-center">
            <span class="text-lg font-bold">🙌 Thanks for signing up!</span><br /><br />Before getting started, could you verify your email address by clicking on the link we just sent to you?<br /><br /><span class="text-sm">If you didn’t receive the email, please check your spam. We can also send you another.</span>
        </div>

        <div class="mb-4 font-medium text-sm text-green-600 text-center" v-if="verificationLinkSent" >
            A new verification link has been sent to the email address you provided during registration.
        </div>

        <form @submit.prevent="submit">
            <div class="mt-6 flex items-center justify-between">
                <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    Resend Verification Email
                </jet-button>

                <inertia-link :href="route('logout')" method="post" as="button" class="underline text-sm text-gray-600 hover:text-gray-900">Log Out</inertia-link>
            </div>
        </form>
    </jet-authentication-card>
</template>




<script>
    import JetAuthenticationCard from '@/Jetstream/AuthenticationCard'
    import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
    import JetButton from '@/Jetstream/Button'
    import { router } from '@inertiajs/vue3'

    export default {
        components: {
            JetAuthenticationCard,
            JetAuthenticationCardLogo,
            JetButton,
        },

        props: {
            status: String
        },

        data() {
            return {
                form: {}
            }
        },

        methods: {
            submit() {
                router.post(this.route('verification.send'), this.form)
            },
        },

        computed: {
            verificationLinkSent() {
                return this.status === 'verification-link-sent' 
            }
        }
    }
</script>
